import React, {useContext, useEffect, useState} from "react";
import {Card, Row} from "react-bootstrap";
import {RequestContext} from "../../context/RequestContext";
import _ from "lodash";
import { FieldTypes } from "../../constants/FieldTypes";
import "../../styles/card.scss";
import {StyledBlueButton} from "../../styles/BootstrapStyles";
import JobUtils from "../../utils/JobsUtils";
import ConfigUtils from "../../utils/ConfigUtils";
import RequestUtils from "../../utils/RequestUtils";
import moment from "moment";

const Process = ({ process, hasMultipleEcoProcesses }) => {
  const inputComponents = ConfigUtils.getInputComponents();
  const metadata = _.get(inputComponents, "inputComponents[0].dataFields[0]");
  const {
    _setSelectedProcess,
    _setShowProcessForm,
    deleteProcess,
    addNewProcess,
    status
  } = useContext(RequestContext);
  const [sortedProcess, setSortedProcess] = useState({});

  useEffect(() => {
    let sortProcess = {};
    _(process).keys().sort().each((key) => {
      sortProcess[key] = process[key];
    });
    const sortedProcess = JobUtils.sortProcessingMetadata(sortProcess);
    setSortedProcess(sortedProcess);
  }, [process]);

  const handleEdit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    _setSelectedProcess(process);
    _setShowProcessForm(true);
  };

  const handleCopy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!hasMultipleEcoProcesses()) {
      addNewProcess(_.omit(process, "key"));
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    deleteProcess(process);
  };

  const getFieldValue = (metadataField, value) => {
    let fieldType = _.get(metadataField, "type");
    if (fieldType === FieldTypes.BOOLEAN) {
      return value === true ? "Yes" : "No";
    } else if (fieldType === FieldTypes.ARRAY) {
      return _.has(value[0], "channelCount") ? _.get(value[0], "channelCount") : "" + value.length;
    } else if (fieldType === FieldTypes.DATE) {
      return moment(value).format("MM/DD/YY");
    } else if (fieldType === FieldTypes.TIME) {
      return moment(value, 'HH:mm').format('hh:mm A');
    }
    return value;
  }

  const getFileTypeValue = (processFile, value) => {
    let processType = RequestUtils.getProcessType(processFile);
    if (!_.isNil(processType)) {
      value = _.get(processType, "group") + " " + _.get(processType, "label");
    }
    return value;
  }

  return (
      <Card className="cardContainer">
        <Card.Body className="cardBody">
          {_.map(sortedProcess, (value, key) => {
            if (key === "fileType" && value !== 'Custom') {
              value = getFileTypeValue(sortedProcess, value);
            }
            let metadataField = _.get(metadata, key);
            return value && metadataField ? (
                <Row className="cardRow" key={"row" + key}>
                  <label className="cardLabel">{ _.get(metadataField, "label") + ":" }</label>
                  <span className="cardText">{getFieldValue(metadataField, value)}</span>
                </Row>
            ) : null;
          })}
        </Card.Body>
        <Card.Footer className="cardFooter">
          <Row className="cardButtonRow">
            <StyledBlueButton
                className="cardButton"
                id={"edit"}
                onClick={handleEdit}>
              Edit
            </StyledBlueButton>
            <StyledBlueButton
                className="cardButton"
                id={"copy"}
                disabled={!JobUtils.isDrafting(status)}
                onClick={handleCopy}>
              Copy
            </StyledBlueButton>
            <StyledBlueButton
                className="cardButton"
                id={"delete"}
                disabled={!JobUtils.isDrafting(status)}
                onClick={handleDelete}>
              Delete
            </StyledBlueButton>
          </Row>
        </Card.Footer>
      </Card>
  );
}

export default React.memo(Process);